(ns frontend.view.modals.db
  (:require [frontend.db :as app-db]
            [reagent.core :as r]))

(defonce state (r/cursor app-db/app-state [:new-modals]))
